import { render, staticRenderFns } from "./Benvenuti.vue?vue&type=template&id=95bf08f4&scoped=true&"
import script from "./Benvenuti.vue?vue&type=script&lang=js&"
export * from "./Benvenuti.vue?vue&type=script&lang=js&"
import style0 from "./Benvenuti.vue?vue&type=style&index=0&id=95bf08f4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95bf08f4",
  null
  
)

export default component.exports